<h1>Anmeldung</h1>
<p>Um die Anwendung nutzen zu können, musst du dich mit deiner cronos-ID anmelden.</p>
<button class="btn" (click)="login()">Login</button>
